<template>
  <div class="content" v-on:click="sectionClicked">
    <div class="contentTop">
      <div class="lthHeaderCnt">
        <div class="lBtn add" v-on:click="addContent" v-if="parent">New Content</div>
        <div class="searchCnt" :class="{open: searchOpen}">
          <form v-on:submit.prevent="search">
            <input type="text" class="field" placeholder="Search content..."
              v-on:input="search" v-model="query" ref="search">
            <button></button>
          </form>
          <div class="pageBtn close" v-on:click="searchOpen = false"></div>
          <div class="pageBtn refresh" v-on:click="getData"></div>
        </div>
        <div class="pagination">
          <div class="pageBtn viewType viewListSm" v-on:click="setDensity('sm')"
            :class="{active: density === 'sm'}"></div>
          <div class="pageBtn viewType viewList" v-on:click="setDensity('compact')"
            :class="{active: density === 'compact'}"></div>
          <div class="pageBtn viewType viewListLg" v-on:click="setDensity('default')"
            :class="{active: density === 'default'}"></div>
          <div class="pageBtn viewType viewGrid" v-on:click="setDensity('grid')"
            :class="{active: density === 'grid'}"></div>
          <div class="divider"></div>

          <div class="pageInfo" v-on:click="gotoPage">
            <template v-if="results.length > 0">
              {{((page * limit) + 1).toLocaleString('id')}}-{{((page
              * limit) + results.length).toLocaleString('id')}}
            </template><template v-else>0</template> dari
            {{total.toLocaleString('id')}}</div>
          <div :class="{pageBtn: 1, pagePrev: 1, disabled: page === 0}"
            v-on:click="prevPage"></div>
          <div :class="{pageBtn: 1, pageNext: 1, disabled: ((page
            * limit) + results.length) >= total}"
            v-on:click="nextPage"></div>

          <div class="pageBtn search" v-on:click="openSearch"></div>

          <div class="pageBtn filter" :class="{open: filterOpen}"
            v-on:click.stop="filterOpen = !filterOpen; configOpen = false">
            <div class="ddCnt flex" v-on:click.stop="doNothing" v-if="filterOpen">
              <div class="ddItem ddItemFull">
                <h4>Publish Date</h4>
                <div class="fieldGroup flex">
                  <div class="fieldCnt">
                    <label>From</label>
                    <input type="date" class="field" v-model="ft.from">
                  </div>
                  <div class="fieldCnt">
                    <label>To</label>
                    <input type="date" class="field" v-model="ft.to">
                  </div>
                </div>
                <div class="dateShortcut">
                  <div class="dhItem" v-on:click="ftTime('ft', 'all')">All time</div>
                  <div class="dhItem" v-on:click="ftTime('ft', 'today')">Today</div>
                  <div class="dhItem" v-on:click="ftTime('ft', 'last7')">Last 7 days</div>
                  <div class="dhItem" v-on:click="ftTime('ft', 'thisMonth')">This month</div>
                  <div class="dhItem" v-on:click="ftTime('ft', 'last30')">Last 30 days</div>
                </div>
              </div>
              <div class="ddFooter">
                <div class="ddFooterLeft">
                  <button class="btn btnSecondary clearFilter"
                    v-on:click.stop="clearFilter">Clear Filter</button>
                </div>
                <button class="btn btnSecondary"
                  v-on:click.stop="filterOpen = false">Cancel</button>
                <button class="btn btnPrimary"
                  v-on:click.stop="applyFilter">Apply Filter</button>
              </div>
            </div>
          </div>
          <div class="pageBtn config" :class="{open: configOpen}"
            v-on:click.stop="configOpen = !configOpen; filterOpen = false">
            <div class="ddCnt" v-if="configOpen" v-on:click.stop="doNothing">
              <div class="ddItem">
                <h4>Item Per Page</h4>
                <div class="radioCnt">
                  <div class="radioItem" v-on:click="setItemPerPage(25)">
                    <div :class="{radio: 1, checked: limit === 25}"></div>
                    25 item per page
                  </div>
                  <div class="radioItem" v-on:click="setItemPerPage(50)">
                    <div :class="{radio: 1, checked: limit === 50}"></div>
                    50 item per page
                  </div>
                  <div class="radioItem" v-on:click="setItemPerPage(100)">
                    <div :class="{radio: 1, checked: limit === 100}"></div>
                    100 item per page
                  </div>
                  <div class="radioItem" v-on:click="setItemPerPage(150)">
                    <div :class="{radio: 1, checked: limit === 150}"></div>
                    150 item per page
                  </div>
                  <div class="radioItem" v-on:click="setItemPerPage(250)">
                    <div :class="{radio: 1, checked: limit === 250}"></div>
                    250 item per page
                  </div>
                </div>
              </div>
            </div>
            <div class="ddCnt" v-on:click.stop="doNothing" v-if="configOpen && 1>2">
              <div class="ddItem ddItemLi">
                Add New
              </div>
              <div class="ddItem ddItemLi">
                Go to page
              </div>
              <div class="ddItem ddItemLi">
                Reload data
              </div>
              <div class="ddItem">
                <h4>Item Per Page</h4>
                <select class="field" v-model="limit">
                  <option value="5">5 item per page</option>
                  <option value="10">10 item per page</option>
                  <option value="25">25 item per page</option>
                  <option value="50">50 item per page</option>
                  <option value="100">100 item per page</option>
                  <option value="150">150 item per page</option>
                </select>
              </div>
              <div class="ddItem">
                <h4>View Type</h4>
                <select class="field" v-model="limit">
                  <option value="5">List</option>
                  <option value="10">List Small</option>
                  <option value="25">List Big</option>
                  <option value="50">Thumbnails</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="tabCnt">
        <div class="tabSc">
          <div class="tab tab1 published" :class="{active: tabActive === 'published'}"
            v-on:click="selectTab('published')">Published</div>
          <div class="tab tab2 starred" :class="{active: tabActive === 'starred'}"
            v-on:click="selectTab('starred')">Starred</div>
          <div class="tab tab4 unpublished" :class="{active: tabActive === 'unpublished'}"
            v-on:click="selectTab('unpublished')">Unpublished</div>
          <div class="tab tab99 deleted" :class="{active: tabActive === 'deleted'}"
            v-on:click="selectTab('deleted')">Deleted</div>
        </div>
      </div>
    </div>
    <perfect-scrollbar class="listingCntSc">
      <div class="listingCnt">
        <div class="listingItemCnt">
          <div class="directoryCnt" v-if="parent && parent.submenu.length > 0">
            <div class="dirCnt">
              <div class="dirItem" v-for="(item, i) in parent.submenu" :key="`dir${i}`"
                v-on:click="openDir(item)">
                <div class="dirIcon"></div>
                <h5>{{item.name}}</h5>
              </div>
            </div>
          </div>
          <table>
            <tbody v-if="loading">
              <tr>
                <td colspan="5" class="tdLoading">
                  <div class="loadingArticle"></div>
                </td>
              </tr>
            </tbody>
            <tbody v-else :class="density">
              <tr v-if="results.length < 1" class="loadingTr">
                <td colspan="2" class="loadingCnt">
                <div class="dataEmptyCnt" v-if="results.length < 1">
                  <div class="submissionEmpty">
                    <div class="emptyImg"/>
                    <h4>No Content Created Yet</h4>
                    <p>Content for this category will appear here, add new content by clicking
                      add new content button on top of the page.</p>
                  </div>
                </div>
              </td></tr>
              <tr v-for="(item, i) in results" :key="i">
                <td class="td1">
                  <div class="articleCnt">
                    <div class="thumb" v-if="item.thumb[lang]"
                      :style="{'background-image': `url(${item.thumb[lang]})`}"
                      :class="item.coverStyle">
                    </div>
                    <div class="thumb noImg" v-else></div>
                    <h4><a :href="`${$config.appPath}content/editor/${item.parent.code}?id=${item.id}&dirId=${item.parent.id}`"
                      target="_blank">{{item.title[lang]}}</a></h4>
                    <p v-if="item.position && item.position[lang]">
                      <b>{{item.position[lang]}}</b>
                    </p>
                    <p v-if="item.description[lang]">{{item.description[lang]}}</p>
                    <div class="authorLabel">
                      <div class="labelCnt">
                        <span class="label type" :class="item.type" v-if="item.type">
                          {{item.type.substr(0, 1).toUpperCase()}}{{item.type.substr(1)}}
                        </span>
                        <div class="label symlink" v-if="item.symlinkId">Symlink</div>
                        <span class="label category"
                          v-if="item.categories && item.categories.length > 0">
                          {{item.categories[0].name[lang]}}<template
                            v-if="item.categories.length > 1">
                            +{{item.categories.length - 1}} more
                          </template>
                        </span>
                        <span class="label attachment"
                          v-if="item.type === 'file' && item.media[lang]">
                          {{item.media[lang].name}}
                        </span>
                        <span class="label attachment"
                          v-if="item.attachments[lang] && item.attachments[lang].length > 0">
                          {{item.attachments[lang][0].name}}<template
                            v-if="item.attachments[lang].length > 1">
                            +{{item.attachments[lang].length - 1}} more
                          </template>
                        </span>
                        <span class="label unpublished" v-if="item.isProtected">
                          <template v-if="item.password">Password required</template>
                          <template v-else>Protected</template>
                        </span>
                        <span v-if="item.status === 'unpublished' || item.status === 'pending'"
                          class="label unpublished">Unpublished</span>
                        <span v-else-if="item.status === 'draft'"
                          class="label draft">Draft</span>
                        <span class="label noSearch" v-if="!item.enableSearch"></span>
                        <span class="label noShare" v-if="!item.displayShare"></span>
                      </div>
                      <div class="authorInfo">
                        <template v-if="item.author">
                          <div :class="{authorImg: true, hasPhoto: item.author.avatar}"
                            :style="{'background-image': `url('${item.author.avatar}')`}">
                            <span>{{item.author.name.substr(0,2)}}</span>
                          </div>
                          <h4>{{item.author.name}}</h4>
                        </template>
                        <span class="publishTime">
                          {{item.publishDate | moment('ddd, D MMM YYYY hh:mm')}}
                        </span>
                        <span class="bull" v-if="1>2">
                          &bull;
                        </span>
                        <span class="views" v-if="1>2">
                          <template v-if="item.viewCount > 1">
                            <template v-if="item.viewCount >= 1000000000">
                              {{Math.floor(item.viewCount/1000000000).toLocaleString('id')}}b
                            </template>
                            <template v-else-if="item.viewCount >= 1000000">
                              {{Math.floor(item.viewCount/1000000).toLocaleString('id')}}m
                            </template>
                            <template v-if="item.viewCount >= 1000">
                              {{Math.floor(item.viewCount/1000).toLocaleString('id')}}k
                            </template>
                            <template v-else-if="item.viewCount">
                              {{item.viewCount.toLocaleString('id')}}
                            </template>
                            views
                          </template>
                          <template v-else>{{item.viewCount || 0}} view</template>
                        </span>
                      </div>
                    </div>
                  </div>
                </td>
                <td class="tdAction">
                  <div class="actionWrapper">
                    <div class="action view">
                      <template v-if="item.viewCount > 1">
                        <template v-if="item.viewCount >= 1000000000">
                          {{Math.floor(item.viewCount/1000000000).toLocaleString('id')}}b
                        </template>
                        <template v-else-if="item.viewCount >= 1000000">
                          {{Math.floor(item.viewCount/1000000).toLocaleString('id')}}m
                        </template>
                        <template v-if="item.viewCount >= 1000">
                          {{Math.floor(item.viewCount/1000).toLocaleString('id')}}k
                        </template>
                        <template v-else-if="item.viewCount">
                          {{item.viewCount.toLocaleString('id')}}
                        </template>
                        views
                      </template>
                      <template v-else>{{item.viewCount || 0}} view</template>
                    </div>
                    <div class="action stats" v-on:click.stop="openStats(item)"
                      v-if="item.isDeleted === 0 && item.status === 'published'">
                    </div>
                    <div class="action star" :class="{stared: item.isFeatured}"
                      v-on:click.stop="featured(item, i)"
                      v-if="item.isDeleted === 0"></div>
                    <div class="action more" v-on:click="itemOpenedId = item.id"></div>
                    <div :class="{actionOverlay: true, open: itemOpenedId == item.id}"
                      v-on:click="itemOpenedId = null"></div>
                    <div :class="{actionCnt: true, open: itemOpenedId == item.id}"
                      v-if="item.isDeleted === 1">
                      <div class="actionItem" v-on:click="restoreItem(i, item)">
                        <img src="../assets/move-file.png"> Restore
                      </div>
                      <div class="divider"></div>
                      <div class="actionItem actionRed" v-on:click="deletePermanent(i, item)">
                        <img src="../assets/delete.png"> Delete permanent
                      </div>
                    </div>
                    <div :class="{actionCnt: true, open: itemOpenedId == item.id}"
                      v-else>
                      <div class="actionItem" v-on:click="editData(i, item)">
                        <img src="../assets/edit-black.png"> Edit Content
                      </div>
                      <div class="actionItem" v-on:click="genEnglish(i, item)">
                        <img src="../assets/language.png"> Auto Translate to English
                      </div>
                      <div class="actionItem" v-on:click="genBahasa(i, item)">
                        <img src="../assets/language.png"> Auto Translate to Bahasa
                      </div>
                      <template v-if="item.status === 'published'">
                        <div class="divider"></div>
                        <a :href="`${$config.frontEnd}insights/${item.parent.code}/${item.code}`"
                          v-on:click="itemOpenedId = null" class="actionItem" target="_blank">
                          <img src="../assets/external-link-black.png"> Open Content
                        </a>
                        <div class="actionItem" v-on:click="copyUrl(i, item)">
                          <img src="../assets/copy.png"> Copy Content Url
                        </div>
                      </template>
                      <div class="divider"></div>
                      <div class="actionItem" v-on:click="duplicate(i, item)">
                        <img src="../assets/copy.png"> Duplicate
                      </div>
                      <div class="actionItem" v-on:click="copyTo(i, item)">
                        <img src="../assets/copy-files.png"> Copy to
                      </div>
                      <div class="actionItem" v-on:click="moveTo(i, item)">
                        <img src="../assets/move-file.png"> Move to
                      </div>
                      <div class="divider"></div>
                      <div class="actionItem" v-on:click="linkTo(i, item)">
                        <img src="../assets/doc-link.png"> Link to Another Directory
                      </div>
                      <div class="divider"></div>
                      <div class="actionItem" v-on:click="addToHome(i, item)">
                        Add to Homescreen
                      </div>
                      <template
                        v-if="['published', 'pending', 'unpublished'].includes(item.status)">
                        <div class="divider"></div>
                        <div class="actionItem" v-on:click="unpublish(i, item)"
                          v-if="item.status === 'published'">
                          <img src="../assets/private-o.png"> Unpublish
                        </div>
                        <div class="actionItem" v-on:click="publish(i, item)"
                          v-if="item.status === 'pending' || item.status === 'unpublished'">
                          <img src="../assets/public.png"> Publish
                        </div>
                      </template>
                      <div class="divider"></div>
                      <div class="actionItem actionRed" v-on:click="deleteData(i, item)">
                        <img src="../assets/delete.png"> Delete
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="tableInfo" v-if="!loading">
            Displaying {{limit.toLocaleString('id')}}
            of {{total.toLocaleString('id')}}
            items<br />&copy; {{$config.copyright}}. Powered by <a href="https://cmsriver.com"
            target="_blank">CMSRiver</a>
          </div>
        </div>
      </div>
    </perfect-scrollbar>

    <Confirmation ref="confirmDialog"/>
    <Snackbar ref="snackbar"/>
    <MediaSelector ref="mediaSelector"/>
    <LoadingDialog ref="loadingDialog" />
    <FormInputerShort ref="formInputer"/>
    <MoveDialog ref="moveDialog"/>
    <CopyDialog ref="copyDialog"/>
    <Analytic ref="analytic"/>
    <ContentSelector ref="contentSelector"/>
    <AddGalery ref="addGalery"/>
    <AddVideo ref="addVideo"/>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Confirmation from '@/components/Confirmation.vue';
import Snackbar from '@/components/Snackbar.vue';
import MediaSelector from '@/components/MediaSelector.vue';
import LoadingDialog from '@/components/LoadingDialog.vue';
import FormInputerShort from '@/components/FormInputerShort.vue';
import MoveDialog from '@/components/MoveDialog.vue';
import CopyDialog from '@/components/CopyDialog.vue';
import Analytic from '@/components/Analytic.vue';
import ContentSelector from '@/components/ContentSelector.vue';
import AddGalery from '@/components/AddGalery.vue';
import AddVideo from '@/components/AddVideo.vue';

export default {
  name: 'articles',
  components: {
    Confirmation,
    Snackbar,
    MediaSelector,
    LoadingDialog,
    FormInputerShort,
    MoveDialog,
    Analytic,
    CopyDialog,
    ContentSelector,
    AddGalery,
    AddVideo,
  },
  data() {
    return {
      limit: 5,
      page: 0,
      total: 0,
      density: 'default',
      parent: null,
      loading: true,
      results: [],
      itemOpenedId: null,
      searchTimer: null,
      query: '',
      tabActive: 'published',
      configOpen: false,
      filterOpen: false,
      searchOpen: false,
      ft: {
        from: '',
        to: '',
      },
    };
  },
  computed: {
    ...mapState(['lang']),
  },
  methods: {
    ...mapActions(['chTitle', 'chCGB', 'chDirId']),
    sectionClicked() {
      this.configOpen = false;
      this.filterOpen = false;
    },
    openSearch() {
      this.searchOpen = true;
      setTimeout(() => {
        this.$refs.search.focus();
      }, 200);
    },
    editData(i, item) {
      this.itemOpenedId = null;
      this.$router.push(`/content/editor/${item.parent.code}?id=${item.id}&dirId=${item.parent.id}`);
    },
    ftTime(type, status) {
      if (status === 'all') {
        this[type].from = '';
        this[type].to = '';
      } else if (status === 'today') {
        const d = new Date();
        this[type].from = moment(d).format('YYYY-MM-DD');
        this[type].to = moment(d).format('YYYY-MM-DD');
      } else if (status === 'last7') {
        const d = new Date();
        const d2 = new Date();
        d2.setDate(d2.getDate() - 7);
        this[type].from = moment(d2).format('YYYY-MM-DD');
        this[type].to = moment(d).format('YYYY-MM-DD');
      } else if (status === 'thisMonth') {
        const d = new Date();
        const d2 = new Date();
        d2.setDate(1);
        this[type].from = moment(d2).format('YYYY-MM-DD');
        this[type].to = moment(d).format('YYYY-MM-DD');
      } else if (status === 'last30') {
        const d = new Date();
        const d2 = new Date();
        d2.setDate(d2.getDate() - 30);
        this[type].from = moment(d2).format('YYYY-MM-DD');
        this[type].to = moment(d).format('YYYY-MM-DD');
      }
    },
    clearFilter() {
      this.$refs.confirmDialog.open({
        title: 'Clear Filter',
        desc: 'Are you sure you want to clear all fiter item?',
        action: 'Clear Filter',
      }, (b) => {
        if (!b) return;
        this.filterOpen = false;
        this.ft.from = '';
        this.ft.to = '';
        this.getData();
      });
    },
    applyFilter() {
      this.filterOpen = false;
      this.getData();
    },
    selectTab(tab) {
      if (tab === this.tabActive) return;
      this.tabActive = tab;
      const { slug } = this.$route.params;
      this.page = 0;
      const dirId = this.$route.query.dirId || '';
      window.history.replaceState({}, tab, `${this.$config.appPath}content/${slug}?dirId=${dirId}&tab=${tab}&page=${this.page}`);
      this.getData();
    },
    setDensity(density) {
      this.configOpen = false;
      localStorage.setItem('articleDensity', density);
      this.density = density;
    },
    setItemPerPage(itemPerPage) {
      this.configOpen = false;
      localStorage.setItem('articleItemPerPage', itemPerPage);
      this.limit = itemPerPage;
      this.getData();
    },
    search(e) {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.getData();
      }, 500);
    },
    copyUrl(i, item) {
      this.itemOpenedId = null;
      // const langCode = (this.lang === 'id') ? 'id-id' : 'en-us';
      const urlToCopy = `${this.$config.frontEnd}insights/${item.parent.code}/${item.code}`;
      this.copyToClp(urlToCopy);
    },
    copyToClp(txt2copy) {
      const m = document;
      const txt = m.createTextNode(txt2copy);
      const w = window;
      const b = m.body;
      b.appendChild(txt);
      if (b.createTextRange) {
        const d = b.createTextRange();
        d.moveToElementText(txt);
        d.select();
        m.execCommand('copy');
      } else {
        const d = m.createRange();
        const g = w.getSelection;
        d.selectNodeContents(txt);
        g().removeAllRanges();
        g().addRange(d);
        m.execCommand('copy');
        g().removeAllRanges();
      }
      txt.remove();
      this.$refs.snackbar.open({ content: 'Content url copied to clipboard.' });
    },
    deletePermanent(i, item) {
      this.itemOpenedId = null;
      const name = (item.name) ? item.name : 'Content';
      this.$refs.confirmDialog.open({
        title: `Delete ${name}`,
        desc: `Are you sure you want to delete this content permanently?
          This operation can not be undone.`,
      }, (b) => {
        if (b) this.deleteNow2(i, item);
      });
    },
    restoreItem(i, item) {
      this.itemOpenedId = null;
      const name = (item.name) ? item.name : 'Content';
      this.$refs.confirmDialog.open({
        title: `Restore ${name}`,
        desc: 'Are you sure you want to restore this content?',
        action: 'Restore',
      }, (b) => {
        if (!b) return;
        this.results.splice(i, 1);
        this.$http.get(this.$config.uri(`article/${item.symlinkId || item.id}/restore`)).then((r) => {
          if (r.data.status !== 200) {
            // Display error
            return;
          }
          this.$refs.snackbar.open({ content: 'Content has been restored.' });
        });
      });
    },
    genEnglish(i, item) {
      this.itemOpenedId = null;
      const name = (item.title.id) ? item.title.id : 'Content';
      this.$refs.confirmDialog.open({
        title: 'Auto Translate to English',
        desc: `Are you sure you want to generate content in English for this article?
          If there are content writen in English in this article it will be overwritten.`,
        action: 'Translate',
      }, (b) => {
        if (!b) return;
        this.$refs.loadingDialog.open();
        this.$http.get(this.$config.uri(`article/${item.id}/translate/english`)).then((r) => {
          this.getData();
          this.$refs.snackbar.open(`${name} now available in English`);
        });
      });
    },
    genBahasa(i, item) {
      this.itemOpenedId = null;
      const name = (item.title.id) ? item.title.id : 'Content';
      this.$refs.confirmDialog.open({
        title: 'Auto Translate to Bahasa',
        desc: `Are you sure you want to generate content in Bahasa Indonesia for this article?
          If there are content writen in Bahasa Indonesia in this article it will be overwritten.`,
        action: 'Translate',
      }, (b) => {
        if (!b) return;
        this.$refs.loadingDialog.open();
        this.$http.get(this.$config.uri(`article/${item.id}/translate/bahasa`)).then((r) => {
          this.getData();
          this.$refs.snackbar.open(`${name} now available in Bahasa`);
        });
      });
    },
    deleteData(i, item) {
      this.itemOpenedId = null;
      const name = (item.name) ? item.name : 'Content';
      let desc = `Are you sure you want to delete this content?
        You can find deleted item in Deleted tab.`;
      if (item.symlinkId) {
        desc += ' This will delete this symbolic in this directory, real content will still be published.';
      }
      this.$refs.confirmDialog.open({
        title: `Delete ${name}`,
        desc,
      }, (b) => {
        if (b) this.deleteNow(i, item);
      });
    },
    duplicate(i, item) {
      if (item.symlinkId) {
        this.$refs.confirmDialog.open({
          title: 'Can Not Duplicate Content',
          desc: 'Can not duplicate content of symbolic link, please duplicate real content instead?',
          action: 'Close',
          error: true,
        });
        return;
      }
      this.$refs.confirmDialog.open({
        title: 'Duplicate Content',
        desc: 'Are you sure you want to make a copy of this content?',
        action: 'Duplicate',
      }, (b) => {
        if (!b) return;
        this.itemOpenedId = null;
        this.$refs.loadingDialog.open();
        this.$http.get(this.$config.uri(`article/${item.id}/duplicate`)).then((r) => {
          this.getData();
        });
      });
    },
    addToHome(i, item) {
      this.itemOpenedId = null;
      const formData = { type: 'content', refId: item.id };
      this.$http.post(this.$config.uri('misc/home'), formData).then(() => {
        this.$refs.snackbar.open({ content: 'Item added to home screen' });
      });
    },
    moveTo(i, item) {
      this.itemOpenedId = null;
      this.$refs.moveDialog.open({
        item,
        currentCategoryId: item.parent.id,
        type: 'move',
      }, (b) => {
        if (!b) return;
        this.getData();
      });
    },
    copyTo(i, item) {
      this.itemOpenedId = null;
      this.$refs.moveDialog.open({
        item,
        currentCategoryId: item.parent.id,
        type: 'copy',
      }, (b) => {
        if (!b) return;
        this.getData();
      });
    },
    linkTo(i, item) {
      this.itemOpenedId = null;
      this.$refs.moveDialog.open({
        item,
        currentCategoryId: item.parent.id,
        type: 'link',
      }, (b) => {
        if (!b) return;
        this.getData();
      });
    },
    publish(i, item) {
      this.itemOpenedId = null;
      this.$refs.confirmDialog.open({
        title: 'Publish Content',
        desc: `Are you sure you want to publish this content?
          Content will appear in front-end.`,
        action: 'Publish',
      }, (b) => {
        if (!b) return;
        this.results.splice(i, 1);
        this.$refs.snackbar.open({ content: 'Content has been published.' });
        this.$http.get(this.$config.uri(`article/${item.symlinkId || item.id}/publish`));
      });
    },
    unpublish(i, item) {
      this.itemOpenedId = null;
      this.$refs.confirmDialog.open({
        title: 'Unpublish Content',
        desc: `Are you sure you want to unpublish this content?
          Content will not displayed in front-end.`,
        action: 'Unpublish',
      }, (b) => {
        if (!b) return;
        this.results.splice(i, 1);
        this.$refs.snackbar.open({ content: 'Content has been unpublished.' });
        this.$http.get(this.$config.uri(`article/${item.symlinkId || item.id}/unpublish`));
      });
    },
    deleteNow2(i, item) {
      this.$refs.formInputer.open({
        title: 'Input Password',
        subtitle: `To prevent from accidentally deleted content,
          you need to input your password.`,
        placeholder: 'Password',
        type: 'password',
        action: 'Delete Content',
      }, (b) => {
        if (!b) return;
        this.results.splice(i, 1);
        const uri = (item.symlinkId)
          ? `article/${item.symlinkId}/delete2`
          : `article/${item.id}/delete2`;
        this.$http.get(this.$config.uri(uri))
          .then((response) => {
            if (response.data.status !== 200) {
              // Display error
              return;
            }
            this.$refs.snackbar.open({ content: 'Content has been deleted.' });
          });
      });
    },
    deleteNow(i, item) {
      this.results.splice(i, 1);
      const uri = (item.symlinkId)
        ? `article/${item.symlinkId}/delete`
        : `article/${item.id}/delete`;
      this.$http.get(this.$config.uri(uri)).then((r) => {
        if (r.data.status !== 200) {
          // Display error
          return;
        }
        this.$refs.snackbar.open({ content: 'Content has been deleted.', action: 'Undo' }, (sb) => {
          if (sb) this.undoDelete(i, item);
        });
      });
    },
    undoDelete(i, item) {
      this.$http.get(this.$config.uri(`article/${item.symlinkId || item.id}/restore`)).then((r) => {
        if (r.data.status !== 200) {
          // Display error
          return;
        }
        this.getData();
        this.$refs.snackbar.open({ content: 'Content has been restored.' });
      });
    },
    addContent() {
      if (!this.parent) return;
      this.$refs.contentSelector.open((b, o) => {
        if (!b) return;
        if (o === 'article') {
          this.$router.push(`/content/editor/${this.parent.code}`);
        } else if (o === 'gallery') {
          this.$refs.mediaSelector.open({ type: 'image' }, (b2, media) => {
            if (!b2) return;
            const theMedia = (media.gallery) ? media.gallery : [media];
            const mids = [];
            // eslint-disable-next-line
            for (const m of theMedia) {
              mids.push(m.id);
            }
            this.$router.push(`/content/editor/${this.parent.code}?type=${o}&mids=${mids}`);
          });
        } else if (o === 'video') {
          this.$refs.mediaSelector.open({ type: 'video' }, (b2, media) => {
            if (!b2) return;
            const m = (media.gallery) ? media.gallery[0] : media;
            if (m.type !== 'video') {
              this.$refs.confirmDialog.open({
                title: 'Media Not Supported',
                desc: 'Only support media type video for video posting',
                error: true,
              });
              return;
            }
            this.$router.push(`/content/editor/${this.parent.code}?type=${o}&mid=${m.id}`);
          });
        } else if (o === 'audio') {
          this.$refs.mediaSelector.open({ type: 'audio' }, (b2, media) => {
            if (!b2) return;
            const m = (media.gallery) ? media.gallery[0] : media;
            if (m.type !== 'audio') {
              this.$refs.confirmDialog.open({
                title: 'Media Not Supported',
                desc: 'Only support media type audio for audio posting',
                error: true,
              });
              return;
            }
            this.$router.push(`/content/editor/${this.parent.code}?type=${o}&mid=${m.id}`);
          });
        } else if (o === 'pdf') {
          this.$refs.mediaSelector.open({ type: 'pdf' }, (b2, media) => {
            if (!b2) return;
            const m = (media.gallery) ? media.gallery[0] : media;
            if (m.type !== 'pdf') {
              this.$refs.confirmDialog.open({
                title: 'Media Not Supported',
                desc: 'Only support media type pdf for pdf document posting',
                error: true,
              });
              return;
            }
            this.$router.push(`/content/editor/${this.parent.code}?type=${o}&mid=${m.id}`);
          });
        } else if (o === 'file') {
          this.$refs.mediaSelector.open({ type: 'all' }, (b2, media) => {
            if (!b2) return;
            const m = (media.gallery) ? media.gallery[0] : media;
            if (m.type === 'video' && m.mimetype === 'video/youtube') {
              this.$refs.confirmDialog.open({
                title: 'Media Not Supported',
                desc: 'Youtube video not supported for file download type content',
                error: true,
              });
              return;
            }
            this.$router.push(`/content/editor/${this.parent.code}?type=${o}&mid=${m.id}`);
          });
        } else if (o === 'profile') {
          this.$router.push(`/content/editor/${this.parent.code}?type=${o}`);
        } else if (o === 'event') {
          this.$refs.confirmDialog.open({
            title: 'Input Event Date',
            desc: 'Please input event information below',
            action: 'Continue',
            inputs: [
              {
                label: 'Start Date',
                type: 'datetime-local',
                placeholder: ' ',
                helper: 'When this event will started',
                value: { id: '', en: '' },
              },
              {
                label: 'End Date',
                type: 'datetime-local',
                placeholder: ' ',
                value: { id: '', en: '' },
              },
              {
                label: 'Event Url',
                placeholder: 'https://',
                type: 'text',
                helper: 'Event registration url or event url',
                value: { id: '', en: '' },
              },
            ],
          }, (b2, c, d, v) => {
            if (!b2) return;
            const uri = `/content/editor/${this.parent.code}?type=${o}`
              + `&d1=${encodeURIComponent(v[0].value.id)}`
              + `&d2=${encodeURIComponent(v[1].value.id)}`
              + `&uri=${encodeURIComponent(v[2].value.id)}`;
            this.$router.push(uri);
          });
        } else if (o === 'link') {
          this.$refs.formInputer.open({
            title: 'Input Link',
            subtitle: 'Type url page will redirect when content got clicked',
            placeholder: 'https://...',
            action: 'Add Link',
          }, (b2, val) => {
            if (!b2) return;
            this.$router.push(`/content/editor/${this.parent.code}?type=${o}&uri=${encodeURIComponent(val)}`);
          });
        }
      });
    },
    gotoPage() {
      this.$refs.confirmDialog.open({
        title: 'Go To Page',
        desc: 'Input page number below',
        input: 'Page number...',
        action: 'Go To Page',
      }, (b, c, d) => {
        if (!b) return;
        const page = Number(d);
        if (Number.isNaN(page)) return;
        this.page = page - 1;
        const { slug } = this.$route.params;
        const dirId = this.$route.query.dirId || '';
        window.history.replaceState({}, `page-${this.page}`, `/content/${slug}?dirId=${dirId}&tab=${this.tabActive}&page=${this.page}`);
        this.getData();
      });
    },
    nextPage() {
      if (((this.page * this.limit) + this.results.length) >= this.total) return;
      this.page += 1;
      const { slug } = this.$route.params;
      const dirId = this.$route.query.dirId || '';
      window.history.replaceState({}, `page-${this.page}`, `/content/${slug}?dirId=${dirId}&tab=${this.tabActive}&page=${this.page}`);
      this.getData();
    },
    prevPage() {
      if (this.page === 0) return;
      this.page -= 1;
      const { slug } = this.$route.params;
      const dirId = this.$route.query.dirId || '';
      window.history.replaceState({}, `page-${this.page}`, `/content/${slug}?dirId=${dirId}&tab=${this.tabActive}&page=${this.page}`);
      this.getData();
    },
    getData() {
      this.loading = true;
      const { slug } = this.$route.params;
      const uri = `article/all/admin?parent=${slug}&limit=${this.limit}&status=${this.tabActive}`
        + `&page=${this.page}&q=${this.query}&pdfrom=${this.ft.from}&pdto=${this.ft.to}`;
      this.$http.get(this.$config.uri(uri)).then((r) => {
        this.loading = false;
        this.$refs.loadingDialog.close();
        this.results = (r.data.status === 200) ? r.data.data : [];
        this.total = (r.data.status === 200) ? r.data.total : 0;
      });
    },
    openStats(item) {
      this.$refs.analytic.open(item);
    },
    featured(item, index) {
      const featured = (item.isFeatured) ? 0 : 1;
      this.results[index].isFeatured = featured;
      this.$http.get(this.$config.uri(`article/${item.id}/featured/${featured}`));
    },
    openDir(item) {
      window.location.href = `${this.$config.appPath}content/${item.code}?name=${item.name}`;
    },
  },
  mounted() {
    this.chCGB(false);
    this.chDirId(parseInt(this.$route.query.dirId, 10));
    this.density = localStorage.getItem('articleDensity') || 'default';
    this.limit = (localStorage.getItem('articleItemPerPage'))
      ? parseInt(localStorage.getItem('articleItemPerPage'), 10) : 5;
    this.tabActive = (this.$route.query && this.$route.query.tab)
      ? this.$route.query.tab : 'published';
    this.page = this.$route.query.page ? Number(this.$route.query.page) : 0;
    if (Number.isNaN(this.page)) this.page = 0;
    this.getData();
    const { slug } = this.$route.params;
    if (slug === 'all') {
      this.chTitle('All Contents');
      this.chDirId(-1);
    } else {
      this.$http.get(this.$config.uri(`article/directory/${slug}?admin=y`)).then((response) => {
        this.parent = response.data.data;
        if (!this.parent.parent) this.chTitle(`Content / ${this.parent.name}`);
        else this.chTitle(`Content / ... / ${this.parent.name}`);
      });
    }
  },
};
</script>


<style scoped lang="scss">
.dataEmptyCnt{
  position: relative;
  height: calc(100vh - 310px);
}
.submissionEmpty{
  text-align: center;
  position: absolute;
  left: 50%; top: 50%;
  transform: translate(-50%, -50%);
  h4{
    margin: 0;
    font-size: 32px;
    color: #767676;
    font-weight: normal;
    margin-bottom: 10px;
  }
  p{
    font-size: 15px;
    color: #767676;
    margin-bottom: 30px;
    max-width: 500px;
    white-space: normal;
    line-height: 1.4;
  }
  .btn{
    // border: #0747a6 2px solid;
    border-radius: 50px;
  }
  .emptyImg{
    width: 300px; height: 300px;
    background-image: url(../assets/trash-empty.png);
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    margin: 0 auto 20px;
  }
}
.listingItemCnt{
  margin: 0 -30px;
}
.tabCnt{
  .tab{
    width: 25%;
  }
}
.listingHeader{
  padding: 5px 20px;
  padding-left: 18px;
  .exportAll{
    float: right;
    background-color: #0057d8;
    font-size: 15px;
    margin-right: 10px;
    padding: 8px 16px;
    border-radius: 40px;
    transition: all .2s linear;
    color: #fff;
    cursor: pointer;
    img{
      height: 20px;
      margin-bottom: -4px;
      margin-right: 5px;
    }
  }
  .exportAll:hover{
    background-color: #0067ff;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
  }
  .lhItem{
    font-size: 15px;
    float: left;
    margin-right: 10px;
    padding: 8px 16px;
    border-radius: 40px;
    opacity: .5;
    transition: all .2s linear;
    cursor: pointer;
    position: relative;
    padding-left: 150px;
    float: none;
    margin-right: 0;
    img{
      height: 20px;
      margin-bottom: -4px;
      margin-right: 5px;
    }
    .checkAll{
      width: 14px; height: 14px;
      border: #777 2px solid;
      border-radius: 4px;
      float: left;
      margin-right: 10px;
    }
    &.addContent{
      display: block;
      color: #444;
    }
  }
  .lhItem.rejectAll{
    opacity: 1;
    color: red;
  }
  .lhItem:before{
    content: "";
    position: absolute;
    left: 12px; top: 2px;
    width: 120px; height: 30px;
    background-color: #ddd;
    border-radius: 4px;
  }
  .lhItem:hover{
    // background-color: #eee;
    opacity: 1;
  }
}
table{
  border-collapse: collapse;
  width: 100%;
  tr{
    &:hover{
      background-color: #f5f5fe;
    }
    &.loadingTr{
      cursor: default;
      &:hover{
        background-color: #fff;
      }
    }
    th{
      text-align: left;
      font-weight: bold;
      color: #999;
      padding: 10px 0;
      padding-left: 20px;
      border-bottom: #eee 1px solid;
      text-transform: uppercase;
      white-space: nowrap;
    }
    td{
      padding: 14px 0;
      padding-left: 20px;
      border-bottom: #eee 1px solid;
      position: relative;
      white-space: nowrap;
      vertical-align: top;
      &.tdLoading{
        padding: 0 30px;
        // border: none;
        &:hover{
          background-color: #fff;
        }
        .loadingArticle{
          height: calc(100vh - 145px);
          background-image: url(../assets/loading-3.svg);
          background-position: center;
          background-repeat: no-repeat;
          background-size: 50px auto;
          &:before{
            content: "";
            position: absolute;
            left: 0; top: 0; right: 0; bottom: 0;
            background-image: url(../assets/cmsriver-logo.png);
            background-size: 30px auto;
            background-position: center;
            background-repeat: no-repeat;
          }
        }
      }
      .articleCnt{
        min-height: 150px;
      }
      &.loadingCnt{
        padding: 0 30px;
        border-bottom: none;
      }
      .thumb{
        left: 30px;
        top: 14px;
        position: absolute;
        width: 120px;
        height: 150px;
        // height: 80px;
        // top: 20px;
        background-color: #e5e5e5;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        border-radius: 4px;
        opacity: 1;
        display: inline-block;
        &.full{
          background-size: contain;
        }
        &.noImg{
          background-color: #ccc;
          background-image: url(../assets/image-black.png);
          background-size: 36px auto;
          background-position: center;
          background-repeat: no-repeat;
          opacity: .36;
        }
        .prizeMore{
          color: #fff;
          font-size: 12px;
          position: absolute;
          right: 10px; bottom: 10px;
        }
      }
      .actionWrapper{
        position: relative;
        display: flex;
        justify-content: flex-end;
        padding-right: 10px;
        .ttCnt{
          position: relative;
          .tt{
            position: absolute;
            top: 100%; right: -20px;
            background-color: rgba(0,0,0,.8);
            color: #fff;
            padding: 4px 10px;
            border-radius: 3px;
            display: none;
            font-size: 13px;
          }
          &:hover{
            .tt{
              display: block;
            }
          }
        }
      }
      .deliveryStats{
        display: flex;
        font-size: 13px;
        align-items: center;
        color: #767676;
        .statsItem{
          padding: 5px 10px;
          padding-left: 32px;
          position: relative;
          border-radius: 50px;
          cursor: pointer;
          &:before{
            content: "";
            position: absolute;
            left: 10px; top: 0; bottom: 0;
            width: 16px;
            background-position: center;
            background-repeat: no-repeat;
            background-size: contain;
            opacity: .5;
          }
          &:hover{
            background-color: #d7d7ea;
            color: #444;
            &:before{
              opacity: .6;
            }
          }
          &.waStats{
            &:before{
              background-image: url(../assets/whatsapp-o.png);
            }
          }
          &.smsStats{
            &:before{
              background-image: url(../assets/sms-o.png);
            }
          }
        }
      }
      .variant{
        font-weight: 600;
        line-height: 30px;
        margin-right: 10px;
        color: #767676;
        position: relative;
        text-transform: uppercase;
        display: none;
      }
      .status{
        font-weight: 600;
        line-height: 30px;
        margin-right: 10px;
        color: #767676;
        position: relative;
        &:before{
          content: "";
          position: absolute;
          width: 8px; height: 8px;
          border-radius: 50%;
          background-color: #ccc;
          top: 50%; margin-top: -4px;
          left: -16px;
        }
        &.not_started{
          &:before{
            background-color: orange;
          }
        }
        &.live{
          color: red;
          margin-right: 14px;
          margin-top: -4px;
          &:after{
            content: "";
            position: absolute;
            left: -24px; top: 4px; right: -8px; bottom: 6px;
            border: red 1px solid;
            border-radius: 3px;
          }
          &:before{
            margin-top: -5px;
            background-color: red;
            animation: blinking 1.2s ease forwards infinite;
          }
        }
        &.completed{
          &:before{
            background-color: green;
          }
        }
      }
      .action{
        margin-top: -4px;
        position: relative;
        width: 34px;
        height: 34px;
        border-radius: 50%;
        background-image: url(../assets/more.png);
        background-size: 18px auto;
        background-repeat: no-repeat;
        background-position: center;
        opacity: .4;
        cursor: pointer;
        &.star{
          background-image: url(../assets/star.png);
          &.stared{
            opacity: 1;
            background-image: url(../assets/star-active.png);
          }
        }
        &.share{
          background-image: url(../assets/share.png);
        }
        &.stats{
          background-image: url(../assets/stats.png);
        }
        &.winner{
          background-image: url(../assets/trophy.png);
        }
        &.view{
          background-image: url(../assets/eye-o.png);
          border-radius: 5px;
          width: auto !important;
          background-color: transparent !important;
          opacity: .6 !important;
          padding-left: 24px;
          padding-right: 6px;
          font-size: 13px;
          color: #000;
          cursor: default;
          display: flex;
          align-items: center;
          background-position: 0 50%;
        }
        &:hover{
          background-color: #d7d7ea;
          opacity: .7;
        }
      }
      .actionCnt{
        position: absolute;
        background: #fff;
        top: 100%;
        // border: 1px solid #ccc;
        box-shadow: 1px 1px 4px rgba(0,0,0,.2);
        border-radius: 10px;
        padding: 10px 0;
        white-space: nowrap;
        text-align: left;
        right: 14px;
        z-index: 4;
        margin-top: -5px;
        display: none;
        .divider{
          border-top: #eee 1px solid;
          padding-top: 4px;
          margin-top: 4px;
        }
        .actionItem{
          display: block;
          cursor: pointer;
          list-style: none;
          padding: 7px 42px;
          color: #444;
          font-size: 14px;
          min-width: 100px;
          img{
            height: 15px;
            margin: -4px 6px -2px -22px;
            opacity: .7;
          }
        }
        .actionItem.actionRed{
          color: red;
        }
        .actionItem:hover{
          background-color: #eee;
        }
      }
      .actionCnt.open{
        display: block;
      }
      .actionOverlay{
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 3;
        display: none;
      }
      .actionOverlay.open{
        display: block;
      }
    }
    td.td1{
      padding-left: 170px;
      h4{
        margin: 6px 0 14px;
        font-size: 22px;
        font-weight: 600;
        white-space: normal;
        a{
          color: #444;
          &:hover{
            color: #0747a6;
          }
        }
        span{
          background: #777;
          color: #fff;
          font-size: 15px;
          padding: 2px 7px;
          border-radius: 3px;
          margin-left: 10px;
          margin-top: 5px;
        }
      }
      .labelCnt{
        display: flex;
        flex-wrap: wrap;
        align-items: center;
      }
      .label{
        padding: 2px 7px;
        padding-left: 26px;
        color: #767676;
        border-radius: 3px;
        margin-right: 10px;
        margin-bottom: 4px;
        display: block;
        position: relative;
        max-width: 120px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        &:before{
          content: "";
          position: absolute;
          left: 0; top: 0; bottom: 0; width: 20px;
          background-size: 18px auto;
          background-position: center;
          background-repeat: no-repeat;
          opacity: .56;
        }
        .copy{
          width: 20px; height: 20px;
          display: inline-block;
          float: right;
          margin: 1px 0 -4px 4px;
          background-image: url(../assets/copy.png);
          background-size: 16px auto;
          background-position: center;
          background-repeat: no-repeat;
        }
        &.attachment:before{
          background-image: url(../assets/attachment.png);
        }
        &.symlink:before{
          background-image: url(../assets/link-icon.png);
        }
        &.category:before{
          background-image: url(../assets/category-black.png);
        }
        &.noSearch{
          height: 18px;
          &:before{
            background-image: url(../assets/search.png);
          }
          &:after{
            content: "";
            position: absolute;
            width: 2px; height: 100%;
            top: 0; left: 8px;
            background-color: #767676;
            border-right: #fff 2px solid;
            transform: rotate(45deg);
            z-index: 3;
          }
        }
        &.noShare{
          height: 18px;
          &:before{
            background-image: url(../assets/share.png);
          }
          &:after{
            content: "";
            position: absolute;
            width: 2px; height: 100%;
            top: 0; left: 8px;
            background-color: #767676;
            border-right: #fff 2px solid;
            transform: rotate(45deg);
            z-index: 3;
          }
        }
        &.type{
          &.gallery:before{
            background-image: url(../assets/image-black.png);
          }
          &.article:before{
            background-image: url(../assets/listing-black.png);
          }
          &.profile:before{
            background-image: url(../assets/account.png);
          }
          &.video:before{
            background-image: url(../assets/video-black.png);
          }
          &.audio:before{
            background-image: url(../assets/musical-note.svg);
          }
          &.pdf:before{
            background-image: url(../assets/type-pdf.png);
          }
          &.link:before{
            background-image: url(../assets/link-icon.png);
          }
          &.file:before{
            background-image: url(../assets/file-download.png);
            background-size: 16px auto;
          }
          &.event:before{
            background-image: url(../assets/calendar-black.png);
            background-size: 16px auto;
          }
        }
        &.unpublished:before{
          background-image: url(../assets/private.png);
          bottom: 4px;
        }
        &.draft:before{
          background-image: url(../assets/article-black.png);
        }
        &.code{
          background: none;
          border: #0e5dd2 2px dashed;
          border-radius: 0;
          font-weight: 600;
          font-size: 16px;
          color: #0e5dd2;
          margin-right: 14px;
          cursor: text;
          cursor: pointer;
        }
        &.number{
          padding: 2px 4px;
          font-weight: 800;
          color: #444;
          background: none;
          span{
            font-weight: normal;
            color: #767676;
          }
        }
      }
      p{
        margin: -6px 0 8px;
        white-space: normal;
        font-size: 15px;
        color: #767676;
        b{
          font-weight: 600;
        }
      }
      .authorInfo{
        position: relative;
        padding-top: 8px;
        padding-left: 50px;
        padding-bottom: 16px;
        &.noAuthor{
          padding-left: 0;
          padding-top: 6px;
        }
        .authorImg{
          position: absolute;
          left: 0;
          top: 8px;
          width: 39px;
          height: 39px;
          background-color: #ec174c;
          font-weight: 600;
          font-size: 18px;
          // background-image: url(../assets/user.png);
          background-size: cover;
          background-position: center;
          border-radius: 50%;
          // cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          text-transform: uppercase;
          line-height: 0;
          &.hasPhoto{
            span{
              display: none;
            }
          }
        }
        h4{
          margin: 0;
          font-size: 17px;
        }
        .views{
          margin: 0;
          font-size: 13px;
          position: relative;
        }
        .bull{
          margin: 0 8px;
          color: #767676;
        }
        .publishTime{
          margin: 0;
          font-size: 13px;
          position: relative;
          padding-left: 20px;
          &:before{
            width: 14px;
            left: 0; top: 0; bottom: 1px;
            content: "";
            position: absolute;
            background-image: url(../assets/calendar.png);
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
            opacity: .9;
          }
        }
      }
    }
    td.tdHeader{
      padding: 0;
    }
  }
  tbody.compact{
    tr{
      td{
        &.td1{
          .articleCnt{
            min-height: 120px;
            .thumb{
              height: 120px;
            }
            h4{
              font-size: 20px;
              margin-bottom: 8px;
            }
            p{
              margin-bottom: 8px;
            }
            .authorLabel{
              display: flex;
              align-items: center;
            }
            .labelCnt{
              position: relative;
              // margin-right: 10px;
              &:after{
                content: "";
                width: 5px; height: 5px;
                border-radius: 50%;
                margin-left: -3px;
                background-color: #767676;
                display: none;
              }
              .label{
                margin-bottom: 0;
              }
            }
            .authorInfo{
              display: flex;
              margin: 0;
              padding: 0;
              .authorImg{
                display: none;
              }
              h4{
                position: relative;
                font-size: 15px;
                // padding-right: 16px;
                margin-right: 17px;
                padding-left: 22px;
                margin-bottom: 0;
                color: #767676;
                &:after{
                  position: absolute;
                  content: "";
                  left: 0; top: 0; bottom: 0;
                  width: 14px;
                  background-image: url(../assets/user-black.png);
                  background-size: 14px auto;
                  background-position: center;
                  background-repeat: no-repeat;
                  opacity: .65;
                }
                &:before{
                  content: "";
                  width: 5px; height: 5px;
                  border-radius: 50%;
                  position: absolute;
                  top: 7px; right: 0;
                  background-color: #767676;
                  display: none;
                }
              }
              .publishTime{
                font-size: 15px;
                color: #767676;
                &:before{
                  top: 0px;
                  opacity: .65;
                }
              }
            }
          }
        }
      }
    }
  }
  tbody.sm{
    tr{
      td{
        &.td1{
          padding: 6px 0 10px;
          padding-left: 98px;
          .articleCnt{
            min-height: 40px;
            .thumb{
              height: 50px; width: 50px;
              top: 16px;
              &.noImg{
                background-size: 20px auto;
              }
            }
            h4{
              font-size: 16px;
              margin-bottom: 8px;
            }
            p{
              font-size: 15px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: 56vw;
              margin-bottom: 2px;
            }
            .authorLabel{
              display: flex;
              align-items: center;
            }
            .labelCnt{
              position: relative;
              // margin-right: 10px;
              &:after{
                content: "";
                width: 5px; height: 5px;
                border-radius: 50%;
                margin-left: -3px;
                background-color: #767676;
                display: none;
              }
              .label{
                margin-bottom: 0;
              }
            }
            .authorInfo{
              display: flex;
              margin: 0;
              padding: 0;
              .authorImg{
                display: none;
              }
              h4{
                position: relative;
                font-size: 15px;
                margin-right: 20px;
                padding-left: 22px;
                margin-bottom: 0;
                color: #767676;
                &:after{
                  position: absolute;
                  content: "";
                  left: 0; top: 0; bottom: 0;
                  width: 14px;
                  background-image: url(../assets/user-black.png);
                  background-size: 14px auto;
                  background-position: center;
                  background-repeat: no-repeat;
                  opacity: .65;
                }
                &:before{
                  content: "";
                  width: 5px; height: 5px;
                  border-radius: 50%;
                  position: absolute;
                  top: 7px; right: 0;
                  background-color: #767676;
                  display: none;
                }
              }
              .publishTime{
                font-size: 15px;
                color: #767676;
                &:before{
                  top: 0px;
                  opacity: .65;
                }
              }
            }
          }
        }
      }
    }
  }
  tbody.grid{
    display: flex;
    flex-wrap: wrap;
    padding: 20px 15px;
    tr{
      width: calc(25% - 30px);
      margin: 0 15px 30px;
      display: block;
      background: none;
      position: relative;
      &.loadingTr{
        width: 100%;
      }
      td{
        display: block;
        border: none;
        &.td1{
          padding: 0;
          .thumb{
            position: static;
            height: 200px;
            width: 100%;
          }
          h4{
            padding: 26px 6px 0;
            font-size: 17px;
          }
          p{
            padding: 0 6px;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 3;
                    line-clamp: 3;
            -webkit-box-orient: vertical;
          }
          .authorLabel{
            padding: 0 10px;
          }
          .authorInfo{
            padding-left: 48px;
            .authorImg{
              width: 36px; height: 36px;
              top: 9px;
            }
            h4{
              font-size: 16px;
              padding: 0;
            }
          }
        }
        &.tdAction{
          position: absolute;
          padding: 0;
          right: 6px; top: 206px; left: 6px;
          width: auto;
          // display: flex;
          // width: 100%;
          display: block;
          .actionWrapper{
            width: 100%;
            padding: 0;
            .action{
              width: 30px; height: 30px;
              margin: 0;
              background-size: 16px auto;
              &.view{
                margin-right: auto;
              }
            }
          }
        }
      }
    }
  }
}

.viewType{
  @media (max-width: 1280px) {
    display: none;
  }
}
.pageInfo{
  @media (max-width: 1060px) {
    display: none;
  }
}
.pageBtn.search{
  display: none;
  @media (max-width: 740px) {
    display: block;
  }
}
.searchCnt{
  @media (max-width: 740px) {
    position: absolute;
    background-color: #fff;
    z-index: 8;
    left: 0; top: 0; bottom: 0;
    width: 100%;
    box-sizing: border-box;
    height: auto;
    padding: 3px 16px;
    transition: all .3s ease;
    opacity: 0;
    visibility: hidden;
    transform: translateY(-10px);
  }
  &.open{
    @media (max-width: 740px) {
      opacity: 1;
      transform: none;
      visibility: visible;
    }
  }
  .pageBtn.close{
    display: none;
    background-image: url(../assets/close.png);
    background-size: 10px auto;
    margin: 0;
    position: absolute;
    top: 5px; right: 20px;
    z-index: 7;
    @media (max-width: 740px) {
      display: block;
    }
  }
  .pageBtn.refresh{
    @media (max-width: 740px) {
      display: none;
    }
  }
  form{
    margin: 0;
    width: 100%;
    display: block;
    input{
      @media (max-width: 740px) {
        box-shadow: none;
        width: 100%;
        box-sizing: border-box;
        padding-left: 36px;
      }
    }
    button{
      @media (max-width: 740px) {
        top: 2px; right: auto; left: 4px;
      }
    }
  }
}


@keyframes blinking {
  0% {background-color: red;}
  70% {background-color: red;}
  80% {background-color: red;}
  100% {background-color: #fff;}
}
</style>
